"use strict";
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/util/isScheduler.js
 ** module id = 380
 ** module chunks = 2
 **/